// extracted by mini-css-extract-plugin
export default {"addToCartControl":"qZ-z","giftCard":"rZ-z","btnContainer":"sZ-z","cartButton":"tZ-z","disabled":"uZ-z"};